import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isSiteUserRole } from '../utils/accessControl';

const SITE_VIEWER_PATH = '/support/site-viewer';
const SITE_USER_ALLOWED_PATHS = new Set([SITE_VIEWER_PATH, '/support/account']);

const SiteUserSupportRedirect = ({ children }) => {
  const { accessContext, isAuthReady, isLoggedIn } = useAuth();
  const { pathname } = useLocation();

  if (
    isAuthReady &&
    isLoggedIn &&
    accessContext &&
    isSiteUserRole(accessContext.role) &&
    !SITE_USER_ALLOWED_PATHS.has(pathname)
  ) {
    return <Navigate to={SITE_VIEWER_PATH} replace />;
  }

  return children;
};

export default SiteUserSupportRedirect;
